import React, { useContext } from 'react';
import classnames from 'classnames';
import License from '../../../License';
import JournalTags from '../_partials/JournalTags';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import TextualContent from '../../TextualContent';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Journal.scss';
var Journal = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, isMature = _b.isMature, deviationId = _b.deviationId, author = _b.author, publishedTime = _b.publishedTime, textContent = _b.textContent, _c = _b.extended, _d = _c === void 0 ? {} : _c, license = _d.license, tags = _d.tags, journalSkinFullwidth = _d.journalSkinFullwidth, className = _a.className, contentClassName = _a.contentClassName;
    var isMobile = useContext(MobileContext);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isLegacy = (textContent === null || textContent === void 0 ? void 0 : textContent.html.type) === 'writer';
    var isLegacyView = isLegacy && !journalSkinFullwidth;
    var isFullWidthView = isLegacy && journalSkinFullwidth;
    return (React.createElement("div", { className: classnames(s['root'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin'], className, contentClassName) },
        isMobile && React.createElement(TextualContent, { deviation: deviation, withArtist: false }),
        isExtendedLoaded && (React.createElement(React.Fragment, null,
            tags && (React.createElement(JournalTags, { key: "detailsTags-".concat(deviationId), tags: tags })),
            React.createElement("div", { className: s['misc'] },
                isMature && React.createElement(MatureIndicator, null),
                React.createElement("div", { className: s['license'] },
                    React.createElement(License, { license: license, author: author, publishedTime: publishedTime })))))));
};
Journal.displayName = 'Journal';
export default Journal;
//# sourceMappingURL=Journal.js.map